import React, { useMemo } from "react";
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getMessaging, isSupported } from "firebase/messaging";
import FirebaseContext from "./FirebaseContext";
import { env } from "build/env";
var firebaseConfig = {
  apiKey: env.CHECKPLEASE_FIREBASE_API_KEY,
  authDomain: env.CHECKPLEASE_FIREBASE_AUTH_DOMAIN,
  databaseURL: env.CHECKPLEASE_FIREBASE_DATABASE_URL,
  projectId: env.CHECKPLEASE_FIREBASE_PROJECT_ID,
  storageBucket: env.CHECKPLEASE_STORAGE_BUCKET,
  messagingSenderId: env.CHECKPLEASE_MESSAGING_SENDER_ID,
  appId: env.CHECKPLEASE_FIREBASE_APP_ID
};
var FirebaseProvider = _ref => {
  var {
    children
  } = _ref;
  var app = useMemo(() => initializeApp(firebaseConfig), []);
  var db = getDatabase(app);
  return /*#__PURE__*/React.createElement(FirebaseContext.Provider, {
    value: {
      app,
      db
    }
  }, children);
};
export default FirebaseProvider;